import { sharedProdEnvironment } from '@atlas-workspace/shared/environments';

export const environment = {
  dns: 'https://44a2384a89703489e6514248eb5b486b@sentry.agilie.com/26',
  ...sharedProdEnvironment,
};
